let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jLWG0")).then(() => parcelRequire('l48Qc'));